import React from 'react';
import App from 'App';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import i18next from 'translations/i18n';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';

//Default values query-client all project
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchInterval: 5000,
            //staleTime: 4000,
            refetchIntervalInBackground: true,
            notifyOnChangeProps: ['data', 'error'],
            retry: 3,
            retryDelay: 3000,
            refetchOnWindowFocus: false
        },
    },
})

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(
    <HelmetProvider>
        <React.Suspense fallback="loading ...">
            <QueryClientProvider client={queryClient}>
                <I18nextProvider i18n={i18next}>
                    <BrowserRouter>
                        <App />
                        <ReactQueryDevtools initialIsOpen={false} />
                    </BrowserRouter>
                </I18nextProvider>
            </QueryClientProvider>
        </React.Suspense>
    </HelmetProvider>
);








